var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: _vm.color,
        viewBox: "0 0 28 32",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M28,12H0v17c0,1.66,1.34,3,3,3h22c1.66,0,3-1.34,3-3V12ZM6,2v2h-3c-1.66,0-3,1.34-3,3v3h28v-3c0-1.66-1.34-3-3-3h-3v-2c0-1.11-.89-2-2-2s-2,.89-2,2v2h-8v-2c0-1.11-.89-2-2-2s-2,.89-2,2Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }